webpackJsonp([1],Array(20).concat([
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);
__webpack_require__(24);
__webpack_require__(25);
__webpack_require__(26);
__webpack_require__(27);
__webpack_require__(28);
__webpack_require__(29);
__webpack_require__(30);
__webpack_require__(31);
__webpack_require__(32);
__webpack_require__(33);
__webpack_require__(34);
__webpack_require__(35);
__webpack_require__(36);
__webpack_require__(37);
__webpack_require__(38);
module.exports = __webpack_require__(39);


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {(function () {
    "use strict";

    $(initPage);
    var isBrowserIE;

    function initPage() {
        $(document).foundation();
        window.sr = scrollReveal();
        isBrowserIE = checkBrowser();
        $(".drawer").drawer();
        swiperSlideScale();
        frontAnimation();
        searchInput();
        frontSiteTop();
        fixedMenu();
        topImageResize();
        topImageScroll();
        subNav();
        toggle();
        menuDropdown();
        compSpotBackground();
        initGallery();
        initInteractiveVideo();

        $(window).on("load", function () {
            metaCredit();
            fixedMenu();
            frontSiteTop();
            topImageResize();
            compSpotBackground();
        }).on("resize", function () {
            fixedMenu();
            frontSiteTop();
            topImageResize();
            compSpotBackground();
            initGallery()
        }).on("scrollstart", function () { }).on("scroll", function () {
            topImageScroll();
            frontSiteTop();
            fixedMenu();
        }).on("scrollstop", function () { }).on("touchmove", function () {
            topImageScroll();
            frontSiteTop();
        });
    }

    function initGallery() {
        if (!$(window).width()) {
            // fix when page is opened in iframe which doesn't have width
            setTimeout(function () {
                initGallery();
            }, 100);
            return;
        }

        if (Modernizr.mq("only screen and (min-width: 1025px)")) {
            swiperGallery("2.5")
        } else if (Modernizr.mq("only screen and (min-width: 641px)")) {
            swiperGallery("1.3")
        } else if (Modernizr.mq("only screen and (max-width: 640px)")) {
            swiperGallery("1");
        }
    }

    function checkBrowser() {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");

        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
        {
            return true;
        } else {
            return false;
        }
    }

    function scaleImage(container, img) {
        var imgRatio;

        if(isBrowserIE) {
            imgRatio = img.get(0).naturalWidth / img.get(0).naturalHeight;
        } else {
            imgRatio = img.width() / img.height();
        }

        // Bug in initial size image in IE without cache
        img.height(container.height());
        img.width(img.height() * imgRatio);

        if (img.width() < container.width()) {
            img.width(container.width());
            img.height(container.width() / imgRatio);
        }
    }

    function frontSiteTop() {
        if (Modernizr.mq("only screen and (min-width: 641px)")) {
            var scrollTop = $(window).scrollTop(),
                targetHeight = $(".comp__brand-intro__content").outerHeight();

            $(".comp__brand-intro").css("height", targetHeight);

            if (targetHeight > scrollTop || scrollTop == targetHeight) {
                $(".background-media").css("bottom", Math.floor(-(.75 * scrollTop)));
            }
        }
    }

    function frontAnimation() {
        $(".comp__brand-intro__background #background-image").velocity({
            bottom: 0,
            opacity: 1
        });

        setTimeout(function () {
            $(".content__text-group").velocity({
                opacity: 1
            }, {
                    complete: function () {
                        $(".content__action").velocity({
                            opacity: 1,
                            duration: 1000
                        })
                    }
                });
        }, 1000);
    }

    function searchInput() {
        $(".drawer-nav .comp__search__icon").on("click", function (event) {
            $(this).velocity({
                right: -20,
                opacity: 0,
                duration: 10
            }, {
                    display: "none"
                });

            $(".drawer-nav .comp__search__input").velocity({
                opacity: 1,
                right: 0,
                duration: 10
            }, {
                    display: "block"
                });

            event.preventDefault();
        });

        $(".drawer-nav .comp__search__input .close").on("click", function (event) {
            $(".drawer-nav .comp__search__icon").velocity("reverse").css("display", "block");
            $(".drawer-nav .comp__search__input").velocity("reverse").css("display", "none");
            event.preventDefault();
        })
    }

    function topImageResize() {
        var hero = $(".comp__project__hero"),
            bg = $(".comp__project__hero .comp__project__hero__background"),
            img = $(".comp__project__hero .comp__project__hero__background img"),
            content = $(".comp__project__hero .comp__project__hero__content");

        if (hero.length > 0) {
            scaleImage(bg, img);

            img.css({
                transform: "translateY(" + (bg.height() - img.height()) / 2 + "px) translateX(" + (bg.width() - img.width()) / 2 + "px)"
            });

            if (Modernizr.mq("only screen and (min-width: 40em)")) {
                content.css({
                    "top": (hero.height() - content.height()) / 2 + ($(window).scrollTop() / 2),
                    "left": ((hero.width() - content.width()) / 2)
                });
            } else {
                content.css({
                    "top": 0,
                    "left": 0
                });
            }
        }
    }


    function fixedMenu() {
        if (Modernizr.mq("only screen and (min-width: 766px)")) {
            var targetPostion = $(".drawer-nav").outerHeight(),
                scrollTop = $(window).scrollTop();

            if (scrollTop > targetPostion || scrollTop > targetPostion) {
                $(".drawer-main").addClass("my-fixed-menu");
            } else if (targetPostion > scrollTop) {
                $(".drawer-main").removeClass("my-fixed-menu");
            }
        }
    }

    function topImageScroll() {
        var hero = $(".comp__project__hero"),
            content = $(".comp__project__hero .comp__project__hero__content"),
            bg = $(".comp__project__hero .comp__project__hero__background"),
            img = $(".comp__project__hero .comp__project__hero__background img");

        if (!hero.length) {
            return;
        }

        if ($(window).scrollTop() < (hero.offset().top + hero.height())) {
            if (Modernizr.mq("only screen and (min-width: 40em)")) {
                content.css({
                    "top": (hero.height() - content.height()) / 2 + ($(window).scrollTop() / 2),
                    "left": ((hero.width() - content.width()) / 2)
                });

                var opacity = ((bg.offset().top + bg.height()) - $(window).scrollTop()) / (bg.offset().top + bg.height());
                var scale = 1 + ($(window).scrollTop() / (img.height() - hero.height()) / (img.width() / img.height()) / 2);

                img.css({
                    "opacity": opacity,
                    "transform": "scale(" + scale + ") translateY(" + (bg.height() - img.height()) / 2 + "px) translateX(" + (bg.width() - img.width()) / 2 + "px)"
                });
            } else {
                content.css({
                    "top": 0,
                    "left": 0
                });
            }
        }
    }

    function subNav() {
        $(".comp__sub-nav__switch").click(function () {
            $(this).parent(".comp__sub-nav").toggleClass("open");
        });
    }
    
    function toggle() {
        $(".comp__toggle__switch").click(function () {
            $(this).next().slideToggle("slow");
            $(this).find(".comp__toggle__switch__arrow").toggleClass("open");
        });
    }
    
    function menuDropdown() {
        $(".drawer-menu-item").click(function() {
            var menu = $(".drawer-menu"),
                menuItem = $(this),
                prevDropdown = menu.find(".expanded"),
                activeMenuItem = menu.find(".active").first();

            if (!menuItem.hasClass("active")) {
                activeMenuItem.removeClass("active");
            }

            if (!menuItem.hasClass("expanded")) {
                prevDropdown.removeClass("expanded");
                prevDropdown.find('.dropdown-menu').first().stop(true, true).slideUp(100);
                $(".overlay").removeClass("opened");
            }

            $(".brand, .overlay, .drawer-service-menu").click(function() {
                closeDropdownAndSetActiveItem(activeMenuItem);
            });

            menu.click(function(ev){
                if(ev.target.className === menu.attr('class')) {
                    closeDropdownAndSetActiveItem(activeMenuItem);
                }
            });
        });

        function closeDropdownAndSetActiveItem(activeMenuItem) {
            var expanded = $(".expanded"),
                overlay = $(".overlay");

            setTimeout(function() {
                overlay.removeClass("opened");
            }, 100);
            expanded.find('.dropdown-menu').first().stop(true, true).slideUp(100);
            expanded.removeClass("expanded");
            activeMenuItem.addClass("active");
        }

        $('.dropdown').click(function(ev) {
            var element = $(this),
                overlay = $(".overlay");

            if (ev.target.className === element.find("[data-toggle]").attr("class")) {
                ev.preventDefault();
            }

            if (element.hasClass("expanded")) {
                element.removeClass("expanded");
                element.find('.dropdown-menu').first().stop(true, true).slideUp(
                    100, function() {
                        if(!$('.dropdown').hasClass("open")) {
                            overlay.removeClass("opened");
                        }
                    }
                );
            } else {
                element.addClass("expanded");
                element.find('.dropdown-menu').first().stop(true, true).slideDown(100);
                overlay.addClass("opened");
            }
        });
    }

    function swiperSlideScale() {
        $(".swiper-slide__text > a").hover(function () {
            $(".swiper-slide-active .swiper-slide__background").addClass("hover");
        }, function () {
            $(".swiper-slide-active .swiper-slide__background").removeClass("hover");
        });
    }

    function swiperGallery(slidesPerView) {
        new Swiper(".comp__swiper--gallery .swiper-container", {
            slidesPerView: slidesPerView,
            paginationClickable: true,
            spaceBetween: 20,
            centeredSlides: true,
            pagination: ".swiper-pagination",
            nextButton: ".swiper-button-next",
            prevButton: ".swiper-button-prev",
            loop: false
        });
    }

    function compSpotBackground() {
        var bg = $('.comp__spot .comp__spot__background'),
            img = $('.comp__spot .comp__spot__background img');

        if ($(".comp__spot").length > 0) {
            setTimeout(function () {
                // Bug in initial size image in IE without cache
                scaleImage(bg, img);

                img.css({
                    "transform": "translateY(" + (bg.height() - img.height()) / 2 + "px) translateX(" + (bg.width() - img.width()) / 2 + "px)"
                });
            });
        }
    }

    function metaCredit() {
        $('p.meta.credit').each(function () {
            if ($(this).text() == '') {
                $(this).css('visibility', 'hidden');
            }
        });
    }

    function initInteractiveVideo() {
        var containerClasses = ['embed-container', 'comp__responsive-video'];
        $('iframe').each(function () {
            var $this = $(this);
            var $parent = $this.parent();
            if ($parent.hasClasses(containerClasses)) return;

            $this.wrap($("<div></div>").addClass(containerClasses[0]));
        });
    }

    $.fn.extend({
        hasClasses: function (selectors) {
            var self = this;
            for (var i in selectors) {
                if ($(self).hasClass(selectors[i]))
                    return true;
            }
            return false;
        }
    });
})();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "boardmembers.html";

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "contact.html";

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "design-element.html";

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fonden.html";

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "frontpage--image.html";

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "frontpage.html";

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "image-style.html";

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "index.html";

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "module-lib.html";

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "news-overview.html";

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "news.html";

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "presserum.html";

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "project--gallery.html";

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "project--video.html";

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "project.html";

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "projects.html";

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "search-results.html";

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static-page.html";

/***/ })
]),[20]);


// WEBPACK FOOTER //
// js/app.min.js